module.exports = __webpack_public_path__ + "static/media/tree-silhouette1.a397dcc6.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/tree-silhouette1.png
// module id = 611
// module chunks = 0